export const FETCH_DEVICES_BY_TYPE_REQUEST = '[DevicesByType] FETCH_DEVICES_BY_TYPE_REQUEST';
export const FETCH_DEVICES_BY_TYPE_SUCCESS = '[DevicesByType] FETCH_DEVICES_BY_TYPE_SUCCESS';
export const FETCH_DEVICES_BY_TYPE_FAILURE = '[DevicesByType] FETCH_DEVICES_BY_TYPE_FAILURE';

export const FETCH_DEVICE_LIST_FOR_TYPE_REQUEST =
  '[DevicesByType] FETCH_DEVICE_LIST_FOR_TYPE_REQUEST';
export const FETCH_DEVICE_LIST_FOR_TYPE_SUCCESS =
  '[DevicesByType] FETCH_DEVICE_LIST_FOR_TYPE_SUCCESS';
export const FETCH_DEVICE_LIST_FOR_TYPE_FAILURE =
  '[DevicesByType] FETCH_DEVICE_LIST_FOR_TYPE_FAILURE';
